export function formatAddress(
  city: string | undefined,
  state: string | undefined,
  zipcode: string | undefined
) {
  const cityState =
    city && state ? `${city}, ${state}${zipcode ? ' ' : ''}` : ''
  return `${cityState}${zipcode || ''}`
}
